import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorBreadcrumbs = LoadableAfterPaint({
	loader: async () => {
		const { EditorBreadcrumbsComponent } = await import(
			/* webpackChunkName: "loadable-EditorBreadcrumbs" */ './EditorBreadcrumbs'
		);
		return EditorBreadcrumbsComponent;
	},
});

export { Breadcrumbs } from './Breadcrumbs';
export { EditorBreadcrumbsLinks } from './EditorBreadcrumbsLinks';

export type {
	EditorBreadcrumbsProps,
	BreadcrumbsItem,
	EditorBreadcrumbOwnProps,
	EditorBreadcrumbActions,
} from './breadcrumbTypes';
